import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authMiddleware } from "./utils/authMiddleware";

const AdminRoute = () => {
	const location = useLocation();
	const condition = authMiddleware();
	const adminRoutes = ['/admin-dashboard', '/admin-user-view'];

	if (!adminRoutes.includes(location.pathname)) {
		return <Navigate to='login' />;
	}
	const isAdmin = condition && localStorage.getItem("userRole") === "admin" && localStorage.getItem("admin_otp_verified") === "true";

	return isAdmin ? <Outlet /> : <Navigate to="/login" />;

}

export default AdminRoute;
